<template>
  <div class="master-group-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.id != null">
              <b-col cols="6" align-self="center">
                <b-form-group v-bind:label="$t('version')" :label-cols="3">
                  <b-form-input class="form-control" v-model="item.version">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <hr/>
              </b-col>
              <div class="col-12">
                <label class="switch switch-icon switch-primary">
                  <input type="checkbox" class="switch-input" @change="checkAll">
                  <span data-on="" data-off="" class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
                <legend class="col-form-label"><b>All</b>
                </legend>
              </div>
              <b-col cols="3" v-for="table in tableSyncData" :key="table.id">
                <label
                  class="switch switch-icon switch-primary">
                  <input type="checkbox" class="switch-input" v-model="item.tableSyncIds" v-bind:value="table.id">
                  <span data-on="" data-off="" class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
                <legend class="col-form-label">{{table.table_name}}</legend>
              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
              <b-button variant="success" v-on:click="updateItem" v-if="id != null && $auth.check(model + '.update')"><i
                class="fa fa-save"></i> {{$t('update')}}
              </b-button>
<!--              <b-button variant="success" v-on:click="createItem" v-if="id == null && $auth.check(model + '.create')"><i-->
              <b-button variant="success" v-on:click="createItem"><i
                class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .switch {
    margin-bottom: 0px;
    margin-top: 7px;
    float: left;
    margin-right: 5px;
  }
</style>
<script>
  import cSwitch from '../../../../components/Switch'
  import {get, create, update} from '@/api/sync_master'
  import {getTableSyncList} from '@/api/table_sync'

  export default {
    name: 'SyncMasterForm',
    props: {
      id: {
        type: String,
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'sync_master',
        tableSyncData: [],
        item: {
          id: null,
          version: '',
          tableSyncIds: []
        },
        languages: Object.keys(this.$i18n.messages)
      }
    },
    methods: {
      /**
       * Update list table sync
       * @param val of switch
       */
      checkAll(val) {
        this.item.tableSyncIds = [];
        if (val.target.checked) {
          for (let i in this.tableSyncData) {
            this.item.tableSyncIds.push(this.tableSyncData[i].id)
          }
        }
      },
      /**
       * List table sync
       */
      getTableSync() {
        this.$Progress.start()
        getTableSyncList().then((response) => {
          this.$Progress.finish()
          this.tableSyncData = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Get details of object
       */
      getDetail() {
        this.$Progress.start()
        let params = {
          id: this.id
        }
        get(params).then((response) => {
          this.item = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        update(this.item).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        create(this.item).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      this.getTableSync()
      if (this.id != null) {
        this.getDetail()
      } else {
        this.item.id = ''
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/inventory/sync_master/Form.vue